import { render, staticRenderFns } from "./addPageEntryInvoice.vue?vue&type=template&id=1218b152&scoped=true&"
import script from "./addPageEntryInvoice.vue?vue&type=script&lang=js&"
export * from "./addPageEntryInvoice.vue?vue&type=script&lang=js&"
import style0 from "./addPageEntryInvoice.vue?vue&type=style&index=0&id=1218b152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218b152",
  null
  
)

export default component.exports